import { CreditAllocationStatus } from "gen/txn/models_pb"
import { useEnumFilter } from "shared-ts/hooks/useFilter"

import { useWebFilter } from "hooks/filters/useWebFilter"

export const CREDITS_TABLE_STATUS_FILTER_KEY = "status"
export function useCreditsTableStatusFilter() {
  return useEnumFilter({
    key: CREDITS_TABLE_STATUS_FILTER_KEY,
    label: "Status",
    enumeration: CreditAllocationStatus,
    labelExtractor: (status: CreditAllocationStatus) => labels[status],
    useFilter: useWebFilter,
  })
}

const labels: Record<CreditAllocationStatus, string> = {
  [CreditAllocationStatus.UNDEFINED]: "",
  [CreditAllocationStatus.UNALLOCATED]: "Unallocated",
  [CreditAllocationStatus.PARTIALLY_ALLOCATED]: "Partially allocated",
  [CreditAllocationStatus.FULLY_ALLOCATED]: "Allocated",
  [CreditAllocationStatus.REFUNDED]: "Refunded",
}
